<template>
  <v-row class="add-member-from-team">
    <v-col>
      <p class="text-grey-900 mb-4 text--small text--bold">
        {{ $t('project.members.AddMemberFromTeam.selectTeam') }}
      </p>
      <!-- Select Team -->
      <AppCombobox :value="memberForm.team"
                   :items="subscriptionTeams"
                   :placeholder="$t('project.members.AddMemberFromTeam.searchTeam')"
                   :error-messages="teamErrors"
                   item-value="id"
                   item-title="name"
                   clearable
                   return-object
                   @input="handleInput"
                   @blur="model.memberForm.team.$touch"
      >
        <template #item="{item, props}">
          <v-list-item v-bind="props">
            <template #title>
              <AddTeamComboboxItem class="mb-2" :item="item.raw" withMembers/>
            </template>
          </v-list-item>
        </template>
      </AppCombobox>

      <div v-if="memberForm.team" class="mt-4 d-flex align-start justify-space-between">
        <div class="flex-grow-1">
          <!-- Team -->
          <AddTeamComboboxItem :item="memberForm.team" />

          <!-- See Members -->
          <AppFlatExpansionPanel style="padding-left: 45px; margin-top: -22px;">
            <template v-slot:title>
              <p class="my-0 text--x-small text--bold text-text-link">
                {{ $t('project.members.AddMemberFromTeam.seeMemmbers') }}
              </p>
            </template>
            <template v-slot:content>
              <div style="max-height: 300px; overflow-y: auto;">
                <div v-for="user in memberForm.team.members"
                     :key="`user-${user.id}`"
                     class="ml-2"
                >
                  <AddMemberFormComboboxItem class="mt-0 mb-3" :item="user" :withCompany="false" />
                </div>
              </div>
            </template>
          </AppFlatExpansionPanel>
        </div>

        <app-button class="mr-2"
                    type="icon"
                    @click="memberForm.team = null">
          <app-material-icon name="close" />
        </app-button>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import { mapState } from 'vuex'

  import AppCombobox from '@/common/AppCombobox.vue'
  import AppFlatExpansionPanel from '@/common/AppFlatExpansionPanel.vue'
  import { formFieldErrors } from '@/common/utils/form'
  import AddMemberFormComboboxItem from '@/project/members/AddMemberFormComboboxItem.vue'
  import AddTeamComboboxItem from '@/project/members/AddTeamComboboxItem.vue'

  export default {
    name: 'AddMemberFromTeam',
    components: {
      AppCombobox,
      AppFlatExpansionPanel,
      AddMemberFormComboboxItem,
      AddTeamComboboxItem,
    },
    props: {
      model: {
        type: Object,
        required: true,
      },
      memberForm: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState('subscription', ['subscriptionTeams']),
      teamErrors () {
        return formFieldErrors(
          this.model.memberForm.team,
          [
            ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('common.form.team') })],
          ],
        )
      },
    },
    methods: {
      handleInput (value) {
        const selectedTeam = this.subscriptionTeams.find(team => team.id === value?.id)
        if (selectedTeam) {
          this.$emit('input', value)
        } else {
          this.$emit('input', null)
        }
      },
    },
  }
</script>
